module.exports = __webpack_public_path__ + "media/scholarships/applied-2ed66002.svg";